export function addHKEventListeners() {
    const elements = Array.from(document.querySelectorAll('.hk-external-entry-point,[href*="#hk-entry-widget-open"]'));

    elements.forEach(element => element.style.pointerEvents = 'none');

    function attachHkEntryPointEvents() {
        const hkEntryWidget = document.getElementById('hk-entry-widget');

        if (hkEntryWidget) {
            elements.forEach(element => {
                const elementIdentifier = element.id || element.text || element.innerHTML;
                element.addEventListener('click', (e) => {
                    e.preventDefault();
                    hkEntryWidget?.dispatchEvent(new CustomEvent('hk-entry-widget-open', { detail: elementIdentifier }));
                });
                element.style.pointerEvents = 'auto';
            });
        } else {
            setTimeout(attachHkEntryPointEvents, 1000);
        }
    }
    attachHkEntryPointEvents();
}